import { Link } from 'react-router-dom';
import { siteInfo, navigationLinks } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-background-50 mb-4 font-[var(--font-heading)]">
              {siteInfo.logo}
            </h3>
            <p className="text-sm leading-relaxed text-background-50/60">
              {siteInfo.tagline}。为成熟用户提供安全、顺畅的漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              使用教程
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/article/latest-access-url"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  最新入口地址
                </Link>
              </li>
              <li>
                <Link
                  to="/article/register-login-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  注册登录教程
                </Link>
              </li>
              <li>
                <Link
                  to="/article/app-download-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  APP下载指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/faq-collection"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  常见问题解答
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="text-sm text-background-50/60">
                <i className="ri-mail-line mr-2"></i>
                {siteInfo.email}
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {siteInfo.year} {siteInfo.name}. 仅供成熟用户访问，未满18周岁请勿浏览。
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors duration-200 whitespace-nowrap"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors duration-200 whitespace-nowrap"
            >
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}